import React, { useState, useEffect } from 'react';
import {
  BackgroundIcon,
  Loader,
  getCurrentUserHook,
  useActivityTracker
} from '@nile/components';
import { Modal } from '@superops/ui-design-system';
import { CustomModal } from '@nile/components';
import styled from 'styled-components';
import envConfig from '@nile/home/src/Config/env';
import { savePersonalization } from '@nile/graphql/src';
import Loading from '@nile/components/src/Svg/AnimatedSvg/Loading.svg';

// .Superops-Modal__BodyWrapper {
//   border-randiis: 30
// }
const Wrapper = styled.div`
  height: 695px;
  width: 1200px;
  overflow-y: hidden;
  border-radius: 10px;
  .loadingContainer {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    svg {
      width: 120px;
      height: 120px;
    }
  }
  overflow: hidden;

  iframe {
    opacity: ${(props) => (props.loading ? '0' : '1')};
    transform: scale(1.02);
  }
`;

const slideMap = {
  '0:119': 'Slide 1',
  '0:125': 'Slide 2',
  '0:121': 'Slide 3',
  '0:123': 'Slide 4'
};

function OnboardingGuide(props) {
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(true);
  const figmaOrigin = 'https://www.figma.com';
  const [slideChanged, setSlideChanged] = useState(false);

  useEffect(() => {
    window.addEventListener('message', (event) => {
      if (event.origin === figmaOrigin) {
        // console.log('event', event);
        switch (event?.data?.type) {
          case 'PRESENTED_NODE_CHANGED':
            const nodeId = event?.data?.data?.presentedNodeId;
            const slide = slideMap?.[nodeId];
            const mixpanelEvent = slide
              ? {
                  event: 'Agent chat Figma onboarding slide changed',
                  data: {
                    slide: slide
                  }
                }
              : {
                  event: 'Agent chat Figma onboarding slide changed'
                };
            if (!slideChanged) {
              setSlideChanged(true);
            }
            useActivityTracker(mixpanelEvent);
            break;
          case 'MOUSE_PRESS_OR_RELEASE':
            const targetNodeId = event?.data?.data?.targetNodeId;
            if (targetNodeId === '5045:10392') {
              if (window?.Intercom('show')) {
                window.Intercom('show');
              }
            } else if (
              event?.data?.data?.targetNodeId ===
                'I3008:29603;253:691;161:140' ||
              event?.data?.data?.targetNodeId ===
                'I3008:29603;253:691;161:143' ||
              event?.data?.data?.targetNodeId === 'I3008:29603;253:691' ||
              event?.data?.data?.targetNodeId === 'I3008:29603;253:691;161:146'
            ) {
              // console.log(event?.data?.data, 'ash:: closing');
              onClose('Agent chat onboarding closed from last slide');
            }
            break;
          default:
            break;
        }
      } else {
        console.warn(
          'Received message from an unexpected origin:',
          event.origin
        );
      }
      if (event.data.type === 'INITIAL_LOAD') {
        setLoading(false);
      }
    });
  }, []);

  const currentUser = getCurrentUserHook();

  function onClose(event) {
    setOpen(false);
    let mixpanelEventOnClose = event ? event : 'Figma onboarding closed';
    useActivityTracker({
      event: mixpanelEventOnClose
    });
    const variables = {
      user: {
        firstName: currentUser?.firstName,
        userId: currentUser?.userId,
        email: currentUser?.email,
        lastName: currentUser?.lastName
      },
      name: 'chat-onboarding-personalisation',
      category: currentUser?.userId,
      value: JSON.stringify({
        chatOnboardingComplete: true
      })
    };
    savePersonalization({
      variables: variables,
      input: variables
    });
  }
  return (
    <>
      {open && (
        <Modal
          large
          open={open}
          onClose={() => onClose()}
          noScroll
          backgroundColor="transparent"
          showCloseButton
          className="figma-onboarding-modal"
        >
          <Wrapper
            className="position-relative"
            id="wrapper-id"
            loading={loading}
          >
            {loading && (
              <div className="loadingContainer">
                <Loading />
                {/* <BackgroundIcon
                  url={`url(${envConfig.imageRoot}svg/Monica-onboarding-loader.svg)`}
                  height={'700px'}
                  width={'1210px'}
                /> */}
              </div>
            )}

            <iframe
              width="100%"
              height="100%"
              // src="https://embed.figma.com/proto/QYCcb6wLSWBabgvq9KX3b3/Monica-AI---Awareness?page-id=0%3A1&node-id=0-13&node-type=frame&viewport=1094%2C387%2C0.14&scaling=fit-width&content-scaling=responsive&embed-host=share&footer=false&disable-default-keyboard-nav=true"
              // src="https://embed.figma.com/proto/jWI78Fkh3bGf6RjEudAcrW/Monica-AI---Awareness?page-id=0%3A1&node-id=0-119&node-type=frame&viewport=697%2C402%2C0.15&scaling=fit-width&content-scaling=responsive&embed-host=share&footer=false&starting-point-node-id=0%3A119&share=1"
              src="https://embed.figma.com/proto/3IBPjSRykdUnGRVJJ6ftZ5/%F0%9F%9F%A9-LIVE-video-file---%F0%9F%92%AC-CHAT?node-id=0-119&viewport=697%2C402%2C0.15&scaling=fit-width&content-scaling=responsive&embed-host=share&footer=false"
              allowfullscreen
            ></iframe>
          </Wrapper>
        </Modal>
      )}
    </>
  );
}

const onBoardingGuideWrapper = (props) => {
  const { onBoardingPersonalisationHook } = props;
  const { saveOnboardingPersonalisation } = onBoardingPersonalisationHook;

  return (
    <OnboardingGuide
      saveOnboardingPersonalisation={saveOnboardingPersonalisation}
    />
  );
};
export default onBoardingGuideWrapper;
